import { currentWallet, getAddEthereumChainParameter, } from '@cronos-app/wallet';
import { BrowserProvider } from 'ethers';
import { useCallback, useRef } from 'react';
import { useWalletConnectModalStore } from './stores';
/**
 * connect to desired chain first
 * then validate chainId, account, provider
 * then call callback
 * @param callback
 * @param desiredChain
 * @returns
 */
export const useTxGuard = (callback, desiredChain) => {
    const cb = useRef(callback);
    cb.current = callback;
    const requireWalletConnectTo = useRequireWalletConnectTo();
    return useCallback(async (...args) => {
        await requireWalletConnectTo(desiredChain);
        const chainId = currentWallet.getStore().getState().chainId;
        const account = currentWallet.getStore().getState().accounts?.[0];
        const provider = currentWallet.getConnector().provider;
        if (!chainId)
            throw new Error('chainId not found');
        if (!account)
            throw new Error('account not found');
        if (!provider)
            throw new Error('provider not found');
        return cb.current({
            chainId,
            account,
            provider: new BrowserProvider(provider),
        }, ...args);
    }, [requireWalletConnectTo, desiredChain]);
};
const useRequireWalletConnectTo = () => {
    const isConnected = currentWallet.useIsConnected();
    const chainId = currentWallet.useChainId();
    const requireWalletConnectTo = useCallback((desiredChain) => {
        if (!isConnected) {
            // not yet connected to wallet
            return useWalletConnectModalStore.getState().openModal(desiredChain)
                .promise;
        }
        else if (chainId !== desiredChain) {
            // connected to wallet, but not connected to the desired chainId
            return currentWallet.connect(getAddEthereumChainParameter(desiredChain));
        }
        // already connected to the desired chainId
        return Promise.resolve();
    }, [isConnected, chainId]);
    return requireWalletConnectTo;
};
